export class PaymentProviderEvent {}
